<script setup lang="ts">
const maxWidths = {
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
};

interface Props {
  maxWidth?: keyof typeof maxWidths;
  noMobilePadding?: boolean;
  tag?: keyof HTMLElementTagNameMap;
}

withDefaults(defineProps<Props>(), { maxWidth: '2xl', tag: 'div' });
</script>

<template>
  <component
    :is="tag"
    class="mx-auto lg:px-4 xl:px-10"
    :class="[maxWidths[maxWidth], { 'px-4': !noMobilePadding }]"
  >
    <slot />
  </component>
</template>
